import { FC } from 'react'

import { Skeleton, Spacer } from '@syconium/little-miss-figgy'

import {
  Body,
  PriceRow,
  TitleRow,
} from '../../../../embroidery/EmbroiderySneakPeek/DigitizationSneakPeek'
import { Template } from '../../../../embroidery/EmbroiderySneakPeek/Template'
import { DeleteIconColumn } from '../PriceAndDeleteButton/styles'

// Mirrors `DigitizationSneakPeek`, which `LogoDigitizationCartItem` renders
export const LogoDigitizationPlaceholder: FC = () => (
  <Body aria-hidden data-testid='logo-digitization-placeholder'>
    <Template.Container>
      <Template.Header isDigitization>
        <Skeleton animated />
      </Template.Header>
      <Template.Body>
        <TitleRow>
          <Skeleton animated height='18px' maxWidth='140px' />
          <DeleteIconColumn>
            <Skeleton animated height='20px' width='20px' />
          </DeleteIconColumn>
        </TitleRow>
        <Spacer height={8} />
        <Skeleton animated height='13px' maxWidth='160px' />
        <Spacer height={8} />
        <Skeleton animated height='13px' maxWidth='120px' />
        <PriceRow>
          <Skeleton animated height='18px' width='48px' />
        </PriceRow>
      </Template.Body>
    </Template.Container>
  </Body>
)
